import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  GenericIconName,
  HeaderButton,
  useValueAfterHydration,
} from '@aboutyou/ui-components';
import React from 'react';
import {useSelectedDiscountColor} from '../../../../backend-services/Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {useWalletStateManager} from '../../../../backend-services/Wallet/utils/useWalletStateManager';
import {useGetCouponsCount} from '../hooks/useGetCouponsCount';
import {useIsCouponWalletActive} from '../hooks/useIsCouponWalletActive';
import {useShowNewCouponsNotificationBadge} from '../hooks/useShowNewCouponsNotificationBadge';
import {useTrackCouponWalletEntryPoint} from '../hooks/useTrackCouponWalletEntryPoint';

export const HeaderCouponWalletButton = () => {
  const {t} = useTranslation();
  const isCouponWalletActive = useIsCouponWalletActive();
  const couponsCount = useValueAfterHydration(useGetCouponsCount());
  const selectedDiscountColor = useValueAfterHydration(
    useSelectedDiscountColor(),
  );
  const notificationBadgeState = useValueAfterHydration(
    useShowNewCouponsNotificationBadge(couponsCount ?? 0),
  );
  const showNewCouponsNotificationBadge =
    notificationBadgeState?.showNewCouponsNotificationBadge;

  const {open} = useWalletStateManager();
  const {featureImpressionRef, trackFeatureClick} =
    useTrackCouponWalletEntryPoint();

  if (!isCouponWalletActive) {
    return null;
  }

  const handleOnClick = () => {
    trackFeatureClick();
    open('coupons');
  };

  return (
    <HeaderButton
      data-testid="HeaderCouponWalletButton"
      asset={GenericIconName.Coupon}
      iconSize="S"
      badgeColor={selectedDiscountColor?.backgroundColor.hex || COLORS.RedSale}
      count={showNewCouponsNotificationBadge ? couponsCount : 0}
      badgeOffset={{
        right: 0,
        top: 2,
      }}
      showBadge={showNewCouponsNotificationBadge}
      onClick={handleOnClick}
      ref={featureImpressionRef}
      aria-label={t('Open coupon wallet')}
    />
  );
};
